// Collect member reason for change
import React from "react";
import { useFormContext } from "react-hook-form";

const Reason = (props) => {
  const { register } = useFormContext();
  return (
    <div className="field">
      <textarea
        id="reason"
        className="member-reason"
        placeholder={props.placeholder}
        {...register("reason")}
      ></textarea>
    </div>
  );
};
export default Reason;
